import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { BiSearch } from "react-icons/bi";
import Products from "../components/Products";
import { Link } from "react-router-dom";

const Shop = () => {
  return (
    <>
      {/* <Header /> */}
      <div className=" px-20 py-10 bg-gray-200 text-center uppercase">
        <h4><Link to='/'>Home</Link> / Shop</h4>
      </div>
      <div className=" px-3 md:px-20 py-10 flex gap-5 flex-col-reverse md:flex-row">
        {/* <div className="  p-5 flex flex-col gap-5">
          <div>
            <h1 className=" mb-5 font-bold">Refine By</h1>
            <ul className=" flex flex-col gap-3">
              <li>
                <input type="checkbox" name="" id="" /> Sale
              </li>
              <li>
                <input type="checkbox" name="" id="" /> New
              </li>
              <li>
                <input type="checkbox" name="" id="" /> In Stock
              </li>
            </ul>
          </div>
          <div>
            <h1 className="  font-bold">Filter By Price</h1>
            <input type="range" name="" id="" className=" text-primary" />
          </div>
          <div>
            <h1 className=" mb-5 font-bold">Color</h1>
            <ul className=" flex flex-col gap-3">
              <li>
                <input type="checkbox" name="" id="" /> Green
              </li>
              <li>
                <input type="checkbox" name="" id="" /> Brown
              </li>
              <li>
                <input type="checkbox" name="" id="" /> Black
              </li>
            </ul>
          </div>
        </div> */}
        <div className=" w-full ">
            <Products/>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Shop;
